import {
  axiosAccess,
  axiosApplication,
  axiosClarification,
  axiosUser,
} from "@config/axiosConfig";
import { ApplicationDetailsPayload } from "@modules/application-section/application-details/types";

export const getApplicationDetails = async (
  payload: ApplicationDetailsPayload,
) => {
  const { access_id } = payload;
  return await axiosAccess.get(`/access_details/${access_id}`);
};

export const getSeekClarificationDetails = async (id: number) => {
  return await axiosApplication.get(
    `/seek-clarification-details?applicationId=${id}`,
  );
};

export const submitSeekClarification = async (payload: any) => {
  return await axiosApplication.post(`/seek-clarification-response`, payload);
};

// EOT Request
export const submitEOTRequest = async (payload: any) => {
  return await axiosUser.post(`/eot-request`, payload);
};
// Provisional License Payment
export const provisionalPayment = async (applicationId: number) => {
  return await axiosApplication.patch(`/provisional-payment/${applicationId}`);
};
// Final NOC Payment
export const finalPayment = async (applicationId: number | string) => {
  return await axiosApplication.patch(`/final-payment/${applicationId}`);
};

// Fees Details
export const getFeesDetails = async (id: number) => {
  return await axiosApplication.get(`/get-fees/${id}`);
};

// Fees Full Details
export const getFeesComponent = async (id: number) => {
  return await axiosApplication.get(`/fees-components/${id}`);
};

export const submitFinalNOCRequest = async (payload: any) => {
  return await axiosApplication.post(`/final-license-request`, payload);
};

// receipt-details
export const getReceiptDetails = async (id: number) => {
  return await axiosApplication.get(`/receipt-details/${id}`, {});
};

export const getPenalityFee = async () => {
  return await axiosApplication.get(`/penalty-details`);
};

export const getIsCheckApplicationSubmitted = async (id: number) => {
  return await axiosApplication.get(`/check-submitted/${id}`);
};

export const submitWithdrawApplication = async (
  application_id: any,
  payload: any,
) => {
  return await axiosApplication.post(`/withdraw/${application_id}`, payload);
};

export const getSeekClarificationDetailsApplicant = async (id: number) => {
  return await axiosClarification.get(`/seek-clk-details?applicationId=${id}`);
};

export const postSeekClarificationResponse = async (payload: any) => {
  return await axiosClarification.post(`/seek-clk-response`, payload);
};

export const submitReviewRequestApi = async (payload: any) => {
  return await axiosApplication.post(`/appeal-request`, payload);
}